<div class="cart-list-item-gift">
  <sd-icon class="icon-size-s" [type]="iconTypes.GIFT"></sd-icon>
  <span class="text-b4-l-500 color-black-warm">подарок</span>
</div>
